const skills =
{
    web_dev: ["ReactJS", "NodeJS", "Express", "Cloud Computing (AWS)", "Docker", "HTML", "CSS", "JavaScript", "React Native", "Python Flask", "Python Jinja", "MYSQL"],
    data_science: ["Data Preprocessing", "Machine Learning", "Data Analytics (Tableau, Power BI)", "Classification (Decision Tree, Logistic Regression, Neural Network, SVM)", "Clustering and Association Mining (K-Means, Apriori)", "Text Analysis and Topic Analysis (NLTK, TF-IDF, LDA, NMF)", "Python", "R Programming Language"],
    soft_skills: ["Team Work", "Self-starter", "Attention to Detail", "Time Management", "Creative Thinking", "Communication"]
}

export default skills;